module.exports = __webpack_public_path__ + "images/emoji/baby.0e0df78e80bb7c9e1a1f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/baby.png
// module id = QwdT
// module chunks = 1